import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import HelpMenu from "../../components/common/HelpMenu";
import { Grid, Typography } from "@mui/material";
import { capitalize } from "../../utils/Utils";
import { ThemeContext } from "../../App";

function SubscriptionExpired(props) {
    let { currentTheme } = useContext(ThemeContext);

    return (<>
        <Helmet>
            <title>Subscription Expired | {capitalize(props?.name || 'SolvCRM')}</title>
        </Helmet>

        <section className="primary-container checkout-layout size-lg">
            <div className="subscription-expired">
                <Grid container spacing={3} alignItems={'center'}>
                    <Grid item xl={1} xs={12} sx={{ 'display': { xl: 'block', xs: 'none' } }}></Grid>
                    <Grid item xl={5} lg={6} xs={12}>
                        {currentTheme?.subscriptionExpiredIllustration}
                    </Grid>
                    <Grid item xl={5} lg={6} xs={12}>
                        <Typography component={'h1'} variant="display-medium-bold" className="block-title">Oops! Your Access is Currently Paused</Typography>
                        <Typography component={'p'} variant="body-large" className="block-description">Your organization’s subscription to SolvCRM has expired. Until it's renewed by your admin, access to the system is temporarily disabled.<br /><br />Please reach out to your admin to resume service. Once the subscription is renewed, you’ll be able to log in as usual.</Typography>
                    </Grid>
                </Grid>
            </div>
        </section>

        <HelpMenu />
    </>);
}

export default SubscriptionExpired;